function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.58 1.12L.382 5.826c-.372.336-.484.988-.282 1.428.202.44.676.874 1.201.874h3.467v23.226c0 .784.866 1.568 1.733 1.568.867 0 1.733-.784 1.733-1.568V8.127H11.7c.525 0 .999-.434 1.2-.873A1.205 1.205 0 0012.62 5.9l-5.2-4.74C6.912.698 6.09.661 5.581 1.12z",
  fill: "#F0AB00",
  fillRule: "nonzero"
});

var SvgScrollArrow = function SvgScrollArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 13 33",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgScrollArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/scroll-arrow.b10b7e02.svg";
export { ForwardRef as ReactComponent };